import { input } from '../../tokens/component';
import { state } from '../../tokens/semantic';

const { toggle } = input.selection;

const MuiSwitch = {
    defaultProps: {
        size: 'medium',
    },
    styleOverrides: {
        root: ({ theme }) => ({
            width: toggle.size.track.minWidth.md,
            height: `calc(${toggle.size.button.md} + ${theme.spacing(0.5)})`,
            padding: theme.spacing(0),
            borderRadius: toggle.effects.radius,
            '&:has(.Mui-focusVisible)': {
                outline: `${state.outline.weight.focus.md} solid ${state.outline.color.focus}`,
                outlineOffset: state.outline.offset.focus.md,
            },
            [theme.breakpoints.down('sm')]: {
                width: toggle.size.track.minWidth.lg,
                height: `calc(${toggle.size.button.lg} + ${theme.spacing(0.5)})`,
                '& .MuiSwitch-thumb': {
                    width: toggle.size.button.lg,
                    height: toggle.size.button.lg,
                },
                '& .MuiSwitch-switchBase.Mui-checked': {
                    transform: `translateX(calc(${toggle.size.track.minWidth.lg} - ${toggle.size.button.lg} - ${theme.spacing(0.5)}))`,
                },
            },
        }),
        switchBase: ({ theme }) => ({
            padding: theme.spacing(0.25),
            '&.Mui-checked': {
                transform: `translateX(calc(${toggle.size.track.minWidth.md} - ${toggle.size.button.md} - ${theme.spacing(0.5)}))`,
                '& + .MuiSwitch-track': {
                    backgroundColor: toggle.color.on.default,
                    opacity: 1,
                },
            },
            '&:hover': {
                backgroundColor: 'transparent',
            },
            '&:hover + .MuiSwitch-track': {
                backgroundColor: toggle.color.off.hover,
            },
            '&.Mui-checked:hover + .MuiSwitch-track': {
                backgroundColor: toggle.color.on.hover,
            },
            '&.Mui-disabled': {
                '& + .MuiSwitch-track': {
                    opacity: toggle.state.disabled.opacity,
                },
            },
        }),
        thumb: ({ theme }) => ({
            width: toggle.size.button.md,
            height: toggle.size.button.md,
            backgroundColor: theme.palette.common.white,
            boxShadow: 'none',
        }),
        track: {
            borderRadius: toggle.effects.radius,
            backgroundColor: toggle.color.off.default,
            opacity: 1,
        },
        sizeSmall: ({ theme }) => ({
            width: toggle.size.track.minWidth.sm,
            height: `calc(${toggle.size.button.sm} + ${theme.spacing(0.5)})`,
            '& .MuiSwitch-thumb': {
                width: toggle.size.button.sm,
                height: toggle.size.button.sm,
            },
            '& .MuiSwitch-switchBase.Mui-checked': {
                transform: `translateX(calc(${toggle.size.track.minWidth.sm} - ${toggle.size.button.sm} - ${theme.spacing(0.5)}))`,
            },
            [theme.breakpoints.down('sm')]: {
                width: toggle.size.track.minWidth.lg,
                height: `calc(${toggle.size.button.lg} + ${theme.spacing(0.5)})`,
                '& .MuiSwitch-thumb': {
                    width: toggle.size.button.lg,
                    height: toggle.size.button.lg,
                },
                '& .MuiSwitch-switchBase.Mui-checked': {
                    transform: `translateX(calc(${toggle.size.track.minWidth.lg} - ${toggle.size.button.lg} - ${theme.spacing(0.5)}))`,
                },
            },
        }),
    },
    variants: [
        {
            props: { size: 'large' },
            style: ({ theme }) => ({
                width: toggle.size.track.minWidth.lg,
                height: `calc(${toggle.size.button.lg} + ${theme.spacing(0.5)})`,
                '& .MuiSwitch-thumb': {
                    width: toggle.size.button.lg,
                    height: toggle.size.button.lg,
                },
                '& .MuiSwitch-switchBase.Mui-checked': {
                    transform: `translateX(calc(${toggle.size.track.minWidth.lg} - ${toggle.size.button.lg} - ${theme.spacing(0.5)}))`,
                },
            }),
        },
    ],
};

export default MuiSwitch;
